define(function (require) {

	//views
	const siteListView = require('./v_cpv_ss_list');
	const TouchEvents = require('civicsUtils/mobile_utility');
	//templates
	const tpl = require('./t_lov_selected_sites.hbs');

/***************************************************************************************************** *
 * This absolutely doesn't need to be it's own view any more. When time allows, integrate it into the main LOV
/***************************************************************************************************** */
	return Marionette.LayoutView.extend({
		template: tpl,
		regions:{
			primarySiteListRegion:'@ui.primarySiteListRegionDiv',
			additionalSiteListRegion:'@ui.additionalSiteListRegionDiv'
		},
		ui: {
			primarySiteListRegionDiv:'.primary-selected-site-list-region',
			additionalSiteListRegionDiv:'.additional-selected-site-list-region',
			viewAllSitesButton: '.view-all-button button',
			noSiteSelected:'.no-site-selected',
			toggleMobileView:'.toggle-mobile-selected-sites-view',
			mapOverlay:'.map-overlay-region',
			mobileEditSitesButton:'.edit-sites-button'
		},
		events: {
			'click @ui.viewAllSitesButton':'showAllSitesButtonClicked',
			'click @ui.toggleMobileView':'toggleMobileView',

			//temporary
			'click @ui.mobileEditSitesButton':'openMobileNewLocationView'
		},
		collectionEvents:{
			'update':function(){
				this.render();
				this.showSiteLists();
				this.ui.mapOverlay.addClass('visible');

			}
		},
		behaviors: {
			touchEvents: {
			  behaviorClass: TouchEvents,
			  targetClass: '.map-overlay-region',
			  direction: 'up'
			}
		},
		className:'selected-sites-view',
		//helps maintain the visible state of the view after a rerender when editing sites.
		isVisible:false,
		initialize: function (options) {
			this.config = options.config;
		},
		onShow:function(){
			this.showSiteLists();
		},
		openMobileNewLocationView:function(){
			//trigger method on parent view
			this.triggerMethod('open:mobile');
		},
		showSiteLists:function(){
			this.primarySiteListRegion.show(new siteListView({
				collection:this.collection,
				isPrimarySiteView:true,
				readOnlyIcons:this.config.constraints.primarySite.readOnly
			}));
			this.additionalSiteListRegion.show(new siteListView({
				collection:this.collection,
				isPrimarySiteView:false,
				readOnlyIcons:this.config.constraints.additionalSites.readOnly
			}));

		},
		showAllSitesButtonClicked:function(e){
			if(e){
				e.stopPropagation();
				e.preventDefault();
			}
			this.collection.trigger('showAllSitesInMap');
			this.onCloseMobileView();
		},
		toggleMobileView:function(e){
			if(e && e.stopPropagation){
				e.stopPropagation();
				e.preventDefault();
			}
			//this.ui.mapOverlay.toggleClass('visible');
			this.isVisible = this.ui.mapOverlay.hasClass('visible');
		},
		onCloseMobileView:function(e){
			if(e && e.stopPropagation){
				e.stopPropagation();
				e.preventDefault();
			}
			this.ui.mapOverlay.removeClass('visible');
			this.isVisible = false;
		},
		templateHelpers: function () {
			return {
				hiddenCSSClass:this.collection && this.collection.length>0 ? '' : ' hidden-on-desktop',
				showEmptyHeader: this.collection && this.collection.length == 0 ? true: false,
				hideViewAllButtonCSSClass:this.collection && this.collection.length>0 ? '' :' hidden',//only show view all if there's more than one site
				mobileVisibleCSSClass:this.isVisible ? ' visible':'',
				mobileEditText:this.collection && this.collection.length>0 ? 
					i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.EDIT_SITES'):
					i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.ADD_SITES'),
				selectedSitesText:this.collection && this.collection.length>1 ?
				i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SELECTED_SITES_TEXT_PLURAL'):
				i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SELECTED_SITES_TEXT_SINGLE'),
			}
		}
	});
});